var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlossary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99951 1C2.44723 1 1.99951 1.44772 1.99951 2V21V23C1.99951 24.1046 2.89494 25 3.99951 25H4.99609L4.99951 25H21.9995C23.1041 25 23.9995 24.1046 23.9995 23V4C23.9995 3.44772 23.5518 3 22.9995 3H21.9995V22.2158C21.9995 22.8426 21.334 22.9997 21.0004 23H20.9995L6.99951 23H3.49951C3.22337 23 2.99951 22.7761 2.99951 22.5C2.99951 22.2247 3.22206 22.0013 3.49709 22H19.9995C20.5518 22 20.9995 21.5523 20.9995 21V2C20.9995 1.44772 20.5518 1 19.9995 1H2.99951ZM9.30879 15.987H14.3183L15.2802 18.9091H18.3183L13.1278 4.72726H10.4802L5.31832 18.9091H8.35641L9.30879 15.987ZM13.5469 13.6201H10.0802L11.804 8.31168L13.5469 13.6201Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlossary);
export default __webpack_public_path__ + "static/media/Glossary.639c51e1966fcb076e1d45d2455e1e55.svg";
export { ForwardRef as ReactComponent };